<div class="upgrade-box">
  <div class="header" fxLayout="row" fxLayoutAlign="start start">
    <mat-icon>lock</mat-icon>
    <div fxLayout="column">
      <h3>{{ title }}</h3>
      <p>{{ body }}</p>
    </div>
  </div>

  <a mat-flat-button class="primary" [href]="externalUrls.LineupUpgrade"> Contact Us To Upgrade </a>
  <a mat-stroked-button class="secondary" [href]="externalUrls.LineupPricing"> View Upgrade Options </a>
</div>
